import React from 'react'

const AccordionClose = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="34" height="34" viewBox="0 0 34 34">
    <g fill="none" fillRule="evenodd" strokeWidth="2">
      <path stroke="#3F5063" d="M9.929 24.071a9.656 9.656 0 0 0 3.314 2.195c1.23.484 2.485.724 3.763.72a10.313 10.313 0 0 0 3.761-.732 9.627 9.627 0 0 0 3.312-2.19 9.627 9.627 0 0 0 2.19-3.312c.484-1.23.725-2.482.724-3.754 0-1.273-.243-2.524-.727-3.755a9.656 9.656 0 0 0-2.195-3.314 9.656 9.656 0 0 0-3.314-2.195 10.188 10.188 0 0 0-3.755-.727c-1.272-.001-2.524.24-3.754.723a9.627 9.627 0 0 0-3.311 2.191 9.627 9.627 0 0 0-2.191 3.312 10.313 10.313 0 0 0-.731 3.761 10.092 10.092 0 0 0 .72 3.763 9.656 9.656 0 0 0 2.194 3.314z" />
      <g fillRule="nonzero" stroke="#6EC18A" strokeLinecap="round">
        <path d="M20.536 20.536l-7.072-7.072M20.655 13.584l-7.07 7.071" />
      </g>
    </g>
  </svg>
)

export default AccordionClose
